"use client";
import dynamic from "next/dynamic";
import React, { useEffect, useState } from "react";
import EmbeddedStripe from "./EmbeddedStripe";
const BaseModalContainer = dynamic(
  () => import("../../components/ui/Feedback/BaseModalContainer"),
  {
    ssr: false,
  }
);
type Props = {
  clientSecret: string | undefined;
  onPaymentCompletionCallback?: () => void;
};

export default function EmbeddedStripeContainer({
  clientSecret,
  onPaymentCompletionCallback,
}: Props) {
  const [isOpen, setIsOpen] = useState<boolean>(clientSecret != undefined);
  useEffect(() => {
    setIsOpen(clientSecret != undefined);
  }, [clientSecret]);
  return (
    <div>
      {isOpen && clientSecret != undefined && (
        <BaseModalContainer
          dismissButtonText={"Cancel"}
          modalContent={
            <EmbeddedStripe
              clientSecret={clientSecret}
              onPaymentCompletionCallback={onPaymentCompletionCallback}
            />
          }
          onModalClose={() => {
            setIsOpen(false);
          }}
          onModalDismiss={() => {
            setIsOpen(false);
          }}
        />
      )}
    </div>
  );
}
